import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class AlertMessageService {
  constructor(private snackBar: MatSnackBar) {}

  success(message: string, action = 'Close') {
    this.alert(message, 'success-snackbar', action);
  }

  error(message: string, action = 'Close') {
    this.alert(message, 'error-snackbar', action);
  }

  info(message: string, action = 'Close', duration?: number) {
    this.alert(message, 'info-snackbar', action, duration);
  }

  private alert(
    message: string,
    panelClass: string,
    action = 'Close',
    durationNumber?: number
  ) {
    this.snackBar.open(message, action, {
      duration: durationNumber >= 0 ? durationNumber : 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: [panelClass, 'snack-bar-line-break'],
    });
  }
}
